import React, { Component, useEffect, useState } from "react";
import HeaderLogin from "../../components/HeaderLogin";
import authAPI from "../../api/authAPI";
import { useLocation, useNavigate } from "react-router";
import PinInput from "react-pin-input";
import Timer from "../../components/Timer";
import AuthenticationManager from "../../services/StorageJWT";
import { Link } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import MasterPage from "../../layouts/MasterPage";
const Otp = () => {
  const [error, setError] = useState("");
  const [code, setCode] = useState("");
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  let statePrev = useLocation();

  useEffect(() => {
    try {
      setMobile(statePrev.state.mobile);
    } catch {
      navigate("/");
    }
  }, [statePrev]);
  const navigate = useNavigate();
  const onSubmit = async () => {
    if (code.length === 4) {
      setLoading(true);
      authAPI
        .otp(mobile, code)
        .then((res) => {
          let _at = new AuthenticationManager();
          _at.updateToken(res);
          if (!res.user.name) navigate("/properties");
          if (res.active_game === "game2") navigate("/two");
          else if (res?.status == 2) navigate("/one/home");
          else if (res.status == 1) navigate("/one");
          else if (res.status == 1.1) navigate("/one/home");
          else if (res.status == 0) navigate("/properties");
          else navigate("/one");
          console.log(res);
        })
        .catch((e) => {
          if (e.response.data.otp) setError(e.response.data.otp[0]);
          else if (e.response.data.error) setError(e.response.data.error);
        })
        .finally(() => setLoading(false));
    } else setError("کد باید ۴ رقمی باشه");
  };
  const finishTime = () => {
    window.history.back();
    // navigate("/")
  };
  return (
    <MasterPage>
      <div
        className="structure-page login p-3  otp"
        style={{ position: "absolute", zIndex: 9,left:0,right:0 }}
      >
        <div className="overflow-hidden">
          <HeaderLogin />
          <div className="form-group text-center mb-5">
            <div>کد تایید ارسال شده به شماره زیر را وارد کنید.</div>
            <div className="d-flex justify-content-center text-center ">
              <div className="pe-2">{mobile}</div>
              <Link
                style={{ color: "#337F51", textUnderlinePosition: "under" }}
                onClick={finishTime}
              >
                {" "}
                ویرایش شماره
              </Link>
            </div>
            <div className="d-flex text-center align-items-center justify-content-center">
              <Timer finishTime={finishTime} time={120} />
              <svg
                className="ms-1"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 21.25C16.5563 21.25 20.25 17.5563 20.25 13C20.25 8.44365 16.5563 4.75 12 4.75C7.44365 4.75 3.75 8.44365 3.75 13C3.75 17.5563 7.44365 21.25 12 21.25Z"
                  stroke="#5C5351"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                />
                <path
                  d="M12 12.9999L15.7123 9.2876"
                  stroke="#5C5351"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.75 1.75H14.25"
                  stroke="#5C5351"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div dir="ltr">
              <PinInput
                length={4}
                initialValue=""
                focus
                onChange={(value, index) => {
                  setCode(value);
                }}
                type="numeric"
                inputMode="number"
                style={{ padding: 1 }}
                inputStyle={{
                  borderRadius: 0,
                  width: 40,
                  // borderColor: "black",
                  borderTop: 0,
                  borderLeft: 0,
                  borderRight: 0,
                }}
                inputFocusStyle={{ width: 40 }}
                onComplete={(value, index) => {
                  setCode(value);
                }}
                autoSelect={true}
                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
              />
            </div>
            <div className="text-start">
              {error != "" && (
                <div className="invalid-feedback d-block">{error}</div>
              )}
            </div>
          </div>
        </div>
        <Button
          disabled={code.length !== 4}
          className="btn btn-submit d-flex align-items-center justify-content-center"
          onClick={onSubmit}
        >
          {loading ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              className="p-2"
              role="status"
              aria-hidden="true"
            />
          ) : (
            " ادامه"
          )}
        </Button>
      </div>
    </MasterPage>
  );
};

export default Otp;
